import React from 'react';

import { getTenantRoutes } from '../../api/tenantRoutes';
import type { TenantRoute } from '../../types';

/** Loads the company's routes once per mount (null while loading or if the fetch fails). */
export default function useTenantRoutes(enabled = true): TenantRoute[] | null {
    const [routes, setRoutes] = React.useState<TenantRoute[] | null>(null);
    const requested = React.useRef(false);

    React.useEffect(() => {
        if (!enabled || requested.current) return;
        requested.current = true;
        getTenantRoutes().then(setRoutes).catch(() => { requested.current = false; });
    }, [enabled]);

    return routes;
}
